/* ============
 * Intercom
 * ============
 *
 * Charge le widget Intercom et démarre la messagerie.
 */
const APP_ID = 'axk4xzw1';

const loadWidget = () => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://widget.intercom.io/widget/${APP_ID}`;
  document.head.appendChild(script);
};

export default {
  boot() {
    if (typeof window.Intercom !== 'function') {
      // Queues the calls made before the widget is loaded, as Intercom's own snippet does.
      const queue = (...args) => queue.q.push(args);
      queue.q = [];
      window.Intercom = queue;

      if (document.readyState === 'complete') {
        loadWidget();
      } else {
        window.addEventListener('load', loadWidget, { once: true });
      }
    }

    window.Intercom('boot', { app_id: APP_ID });
  },
};
